import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import notifierReducer from './notifierReducer';
import usersReducer from '../views/Management/reducers/UsersReducer';
import operatorsReducer from '../views/Management/reducers/OperatorsReducer';
import settingsReducer from '../views/Management/reducers/SettingsReducer';
import reportsReducer from '../views/ReportKpis/reducers/ReportsReducer';
import dashboardInspectReducer from '../views/Dashboard/reducers/DashboardInspectReducer';
import activityViewReducer from '../views/Tracker/reducers/ActivityViewReducer.js';
import elementViewReducer from '../views/Tracker/reducers/ElementViewReducer.js';
import planningReducer from '../views/Builder/reducers/PlanningReducer.js';
import scriptingReducer from '../views/Scripting/reducers/ScriptingReducer';

const rootReducer = combineReducers({
	session: sessionReducer,
	usersReducer,
	notifierReducer,
	operatorsReducer,
	settingsReducer,
	reportsReducer,
	dashboardInspectReducer,
	activityViewReducer,
	elementViewReducer,
	planningReducer,
	scriptingReducer
});

export default rootReducer;
